import { useMemo } from 'react'
import type { MacroBucket } from '../lib/ingredientRegistry'

export type ShopCategoryStyle = {
  tagBg: string
  tagColor: string
}

/** Theme-aware category tag colours — values live in `.shop-screen` CSS vars. */
export function useShopCategoryStyles(): Record<MacroBucket, ShopCategoryStyle> {
  return useMemo(
    () => ({
      proteins: {
        tagBg: 'var(--shop-cat-protein-bg)',
        tagColor: 'var(--shop-cat-protein-text)',
      },
      produce_micros: {
        tagBg: 'var(--shop-cat-produce-bg)',
        tagColor: 'var(--shop-cat-produce-text)',
      },
      fats: {
        tagBg: 'var(--shop-cat-dairy-bg)',
        tagColor: 'var(--shop-cat-dairy-text)',
      },
      carbs: {
        tagBg: 'var(--shop-cat-pantry-bg)',
        tagColor: 'var(--shop-cat-pantry-text)',
      },
    }),
    [],
  )
}
